import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getAllLayers } from 'pxc-editor-core/helpers/schema';
import { colors } from '@/globalStyles';
import { STROKE_DASHARRAY, STROKE_WIDTH } from '@/constants';
import PageMatrixCornerRenderer from './PageMatrixCornerRenderer';

const getMatrixSelectionStyles = data => {
  const { isEditModeEnabled } = data;
  const fill = '#96c8ff88';
  const stroke = colors.primary;
  const strokeWidth = STROKE_WIDTH;
  const strokeDasharray = STROKE_DASHARRAY;
  const pointerEvents = 'none';

  if (isEditModeEnabled) {
    return { fill, stroke, strokeWidth, strokeDasharray, pointerEvents }
  }
  return { fill, stroke, strokeWidth, pointerEvents };
}

const getNextAreaCorner = (currentCorner, matrixSelectionBounds, matrixSelectionCorners) => {
  let result = null;
  if (currentCorner && matrixSelectionCorners) {
    if (currentCorner.type === 'tl' && !currentCorner.line) {
      const corners = matrixSelectionCorners.sort((a, b) => a.x - b.x);
      for (let i = 0; i < corners.length; i++) {
        if (corners[i].y === currentCorner.y && (corners[i].type === 'tr' || corners[i].type === 'bl') && corners[i].x > currentCorner.x) {
          result = corners[i];
          result.line = { start: currentCorner, end: corners[i], type: 'right' };
          i = corners.length;
          return result;
        }
      }
    } else if (currentCorner.line?.type === 'down') {
      let intersects = false;
      if (matrixSelectionBounds?.length) {
        matrixSelectionBounds.forEach(bounds => {
          if (
            ((bounds.isSeparator || Number(bounds.y.toFixed(1)) === Number(currentCorner.y.toFixed(1)) || Number((bounds.y + bounds.height).toFixed(1)) === Number(currentCorner.y.toFixed(1))) &&
              Number(bounds.x.toFixed(1)) < Number(currentCorner.x.toFixed(1)) &&
              Number((bounds.x + bounds.width).toFixed(1)) > Number(currentCorner.x.toFixed(1))) ||
            ((bounds.isSeparator || Number(bounds.x.toFixed(1)) === Number(currentCorner.x.toFixed(1)) || Number((bounds.x + bounds.width).toFixed(1)) === Number(currentCorner.x.toFixed(1))) &&
              Number(bounds.y.toFixed(1)) < Number(currentCorner.y.toFixed(1)) &&
              Number((bounds.y + bounds.height).toFixed(1)) > Number(currentCorner.y.toFixed(1)))
          ) {
            intersects = true;
          }
        });
      }
      if (currentCorner.types.length <= 2 && !intersects) {
        const corners = matrixSelectionCorners.sort((a, b) => b.x - a.x);

        for (let i = 0; i < corners.length; i++) {
          if (corners[i].y === currentCorner.y && corners[i].x < currentCorner.x) {
            result = corners[i];
            result.line = { start: currentCorner, end: corners[i], type: 'left' };
            i = corners.length;
            return result;
          }
        }
      } else {
        const corners = matrixSelectionCorners.sort((a, b) => a.x - b.x);

        for (let i = 0; i < corners.length; i++) {
          if (corners[i].y === currentCorner.y && corners[i].x > currentCorner.x) {
            result = corners[i];
            result.line = { start: currentCorner, end: corners[i], type: 'right' };
            i = corners.length;
            return result;
          }
        }
      }
    } else if (currentCorner.line?.type === 'left') {
      let intersects = false;
      if (matrixSelectionBounds?.length) {
        matrixSelectionBounds.forEach(bounds => {
          if (
            ((bounds.isSeparator || Number(bounds.y.toFixed(1)) === Number(currentCorner.y.toFixed(1)) || Number((bounds.y + bounds.height).toFixed(1)) === Number(currentCorner.y.toFixed(1))) &&
              Number(bounds.x.toFixed(1)) < Number(currentCorner.x.toFixed(1)) &&
              Number((bounds.x + bounds.width).toFixed(1)) > Number(currentCorner.x.toFixed(1))) ||
            ((bounds.isSeparator || Number(bounds.x.toFixed(1)) === Number(currentCorner.x.toFixed(1)) || Number((bounds.x + bounds.width).toFixed(1)) === Number(currentCorner.x.toFixed(1))) &&
              Number(bounds.y.toFixed(1)) < Number(currentCorner.y.toFixed(1)) &&
              Number((bounds.y + bounds.height).toFixed(1)) > Number(currentCorner.y.toFixed(1)))
          ) {
            intersects = true;
          }
        });
      }

      if (currentCorner.types.length <= 2 && !intersects) {
        const corners = matrixSelectionCorners.sort((a, b) => b.y - a.y);

        for (let i = 0; i < corners.length; i++) {
          if (corners[i].x === currentCorner.x && corners[i].y < currentCorner.y) {
            result = corners[i];
            result.line = { start: currentCorner, end: corners[i], type: 'top' };
            i = corners.length;
            return result;
          }
        }
      } else {
        const corners = matrixSelectionCorners.sort((a, b) => a.y - b.y);

        for (let i = 0; i < corners.length; i++) {
          if (corners[i].x === currentCorner.x && corners[i].y > currentCorner.y) {
            result = corners[i];
            result.line = { start: currentCorner, end: corners[i], type: 'down' };
            i = corners.length;
            return result;
          }
        }
      }
    } else if (currentCorner.line?.type === 'top') {
      let intersects = false;
      if (matrixSelectionBounds?.length) {
        matrixSelectionBounds.forEach(bounds => {
          if (
            ((bounds.isSeparator || Number(bounds.y.toFixed(1)) === Number(currentCorner.y.toFixed(1)) || Number((bounds.y + bounds.height).toFixed(1)) === Number(currentCorner.y.toFixed(1))) &&
              Number(bounds.x.toFixed(1)) < Number(currentCorner.x.toFixed(1)) &&
              Number((bounds.x + bounds.width).toFixed(1)) > Number(currentCorner.x.toFixed(1))) ||
            ((bounds.isSeparator || Number(bounds.x.toFixed(1)) === Number(currentCorner.x.toFixed(1)) || Number((bounds.x + bounds.width).toFixed(1)) === Number(currentCorner.x.toFixed(1))) &&
              Number(bounds.y.toFixed(1)) < Number(currentCorner.y.toFixed(1)) &&
              Number((bounds.y + bounds.height).toFixed(1)) > Number(currentCorner.y.toFixed(1)))
          ) {
            intersects = true;
          }
        });
      }
      if (currentCorner.types.length <= 2 && !intersects) {
        const corners = matrixSelectionCorners.sort((a, b) => a.x - b.x);

        for (let i = 0; i < corners.length; i++) {
          if (corners[i].y === currentCorner.y && corners[i].x > currentCorner.x) {
            result = corners[i];
            result.line = { start: currentCorner, end: corners[i], type: 'right' };
            i = corners.length;
            return result;
          }
        }
      } else {
        const corners = matrixSelectionCorners.sort((a, b) => b.x - a.x);

        for (let i = 0; i < corners.length; i++) {
          if (corners[i].y === currentCorner.y && corners[i].x < currentCorner.x) {
            result = corners[i];
            result.line = { start: currentCorner, end: corners[i], type: 'left' };
            i = corners.length;
            return result;
          }
        }
      }
    } else if (currentCorner.line?.type === 'right') {
      let intersects = false;
      if (matrixSelectionBounds?.length) {
        matrixSelectionBounds.forEach(bounds => {
          if (
            ((bounds.isSeparator || Number(bounds.y.toFixed(1)) === Number(currentCorner.y.toFixed(1)) || Number((bounds.y + bounds.height).toFixed(1)) === Number(currentCorner.y.toFixed(1))) &&
              Number(bounds.x.toFixed(1)) < Number(currentCorner.x.toFixed(1)) &&
              Number((bounds.x + bounds.width).toFixed(1)) > Number(currentCorner.x.toFixed(1))) ||
            ((bounds.isSeparator || Number(bounds.x.toFixed(1)) === Number(currentCorner.x.toFixed(1)) || Number((bounds.x + bounds.width).toFixed(1)) === Number(currentCorner.x.toFixed(1))) &&
              Number(bounds.y.toFixed(1)) < Number(currentCorner.y.toFixed(1)) &&
              Number((bounds.y + bounds.height).toFixed(1)) > Number(currentCorner.y.toFixed(1)))
          ) {
            intersects = true;
          }
        });
      }

      if (currentCorner.types.length <= 2 && !intersects) {
        const corners = matrixSelectionCorners.sort((a, b) => a.y - b.y);

        for (let i = 0; i < corners.length; i++) {
          if (corners[i].x === currentCorner.x && corners[i].y > currentCorner.y) {
            result = corners[i];
            result.line = { start: currentCorner, end: corners[i], type: 'down' };
            i = corners.length;
            return result;
          }
        }
      } else {
        const corners = matrixSelectionCorners.sort((a, b) => b.y - a.y);

        for (let i = 0; i < corners.length; i++) {
          if (corners[i].x === currentCorner.x && corners[i].y < currentCorner.y) {
            result = corners[i];
            result.line = { start: currentCorner, end: corners[i], type: 'top' };
            i = corners.length;
            return result;
          }
        }
      }
    }
  }
};

const MatrixSelection = props => {
  const { page, selectedShield, fictiveSections, isMatrixShield } = props;
  const pages = useSelector(state => state.core.pages);
  const sectionsSelection = useSelector(state => state.core.sectionsSelection);
  const fictiveSectionsSelection = useSelector(state => state.core.fictiveSectionsSelection);
  const floatableInputVisible = useSelector(state => state.core.floatableInputVisible);
  const [selectionArea, setSelectionArea] = useState(null);

  let matrixRotation = false;
  if (selectedShield && pages) {
    const layers = getAllLayers(selectedShield.id, pages);
    const { transforms } = layers.group.textStyle;
    matrixRotation = transforms?.angle > 0;
  }

  const getMatrixSelectionArea = () => {
    const matrixSelectionBounds = [];
    let matrixSelectionCorners = [];
    const matrixSelectionLines = [];
    let matrixSelectionContour = '';

    const sepSections = {};
    const rows = {};
    let horizontals = [];
    let sectionsToCheck = [];

    Object.values(fictiveSections).forEach(section => {
      const line1 = Number((matrixRotation ? section.x : section.y).toFixed(10));
      const line2 = Number((matrixRotation ? section.x + section.width : section.y + section.height).toFixed(10));

      if (horizontals.indexOf(line1) < 0) {
        horizontals.push(line1);
      }
      if (horizontals.indexOf(line2) < 0) {
        horizontals.push(line2);
      }
      if (section.type === 'separator') {
        sepSections[section.id] = section;
      }
      if (section.type !== 'separator') {
        sectionsToCheck.push(section);
      }
    });

    horizontals = horizontals.sort((a, b) => a - b);

    if (Object.values(sepSections).length) {
      Object.values(sepSections).forEach(sepSec => {
        if (horizontals?.length > 0) {
          for (let h = 0; h < horizontals.length - 1; h++) {
            const row = Number(horizontals[h].toFixed(10));
            const rowN = Number((horizontals[h + 1] - row).toFixed(10));

            const helpSection = {
              id: sepSec.id + '_' + String(row).replace('.', '_'),
              x: matrixRotation ? row : sepSec.x,
              y: matrixRotation ? sepSec.y : row,
              width: matrixRotation ? rowN : sepSec.width,
              height: matrixRotation ? sepSec.height : rowN,
              type: 'helpSec',
              shieldId: sepSec.shieldId,
              isSelected: false,
            };

            let pushable = true;
            if (sectionsToCheck?.length) {
              sectionsToCheck.forEach(merged => {
                const merged_x = Number(merged.x.toFixed(5));
                const merged_y = Number(merged.y.toFixed(5));
                const merged_xX = Number((merged.x + merged.width).toFixed(5));
                const merged_yY = Number((merged.y + merged.height).toFixed(5));
                const helpSection_x = Number(helpSection.x.toFixed(5));
                const helpSection_y = Number(helpSection.y.toFixed(5));
                const helpSection_xX = Number((helpSection.x + helpSection.width).toFixed(5));
                const helpSection_yY = Number((helpSection.y + helpSection.height).toFixed(5));
                if (merged_x <= helpSection_x && merged_xX >= helpSection_xX && merged_y <= helpSection_y && merged_yY >= helpSection_yY) {
                  pushable = false;
                }
              });
            }
            if (pushable && !fictiveSections[helpSection.id]) {
              fictiveSections[helpSection.id] = helpSection;
            }
          }
        }
      });
    }

    Object.values(fictiveSections).forEach(section => {
      if (isMatrixShield[section.shieldId]) {
        const isSelected = section.type != 'separator' && Boolean(sectionsSelection[section.id] || fictiveSectionsSelection[section.id]);
        if (isSelected) {
          const _x = Number(section.x.toFixed(10));
          const _y = Number(section.y.toFixed(10));
          const _w = Number(section.width.toFixed(10));
          const _h = Number(section.height.toFixed(10));
          const _xw = _x + _w;
          const _yh = _y + _h;
          // find corners
          const pointsToFind = [
            { id: 'p0_' + section.id, x: Number(_x.toFixed(1)), y: Number(_y.toFixed(1)), type: 'tl', top: true, left: true, types: ['tl'] },
            { id: 'p1_' + section.id, x: Number(_xw.toFixed(1)), y: Number(_y.toFixed(1)), type: 'tr', top: true, left: false, types: ['tr'] },
            { id: 'p2_' + section.id, x: Number(_xw.toFixed(1)), y: Number(_yh.toFixed(1)), type: 'br', top: false, left: false, types: ['br'] },
            { id: 'p3_' + section.id, x: Number(_x.toFixed(1)), y: Number(_yh.toFixed(1)), type: 'bl', top: false, left: true, types: ['bl'] },
          ];
          if (matrixSelectionCorners.length > 0) {
            pointsToFind.forEach(point => {
              let found = -1;
              matrixSelectionCorners.forEach((obj, index) => {
                if (obj.x === point.x && obj.y === point.y) {
                  found = index;
                  obj.types.push(point.type);
                }
              });
              if (found < 0) {
                matrixSelectionCorners.push(point);
              }
            });
          } else {
            pointsToFind.forEach(point => {
              matrixSelectionCorners.push(point);
            });
          }
          // selected section bounds
          if (sectionsSelection[section.id]) {
            matrixSelectionBounds.push({
              id: 'bound_' + section.id,
              x: section.x,
              y: section.y,
              width: section.width,
              height: section.height,
              isSeparator: section.type === 'separator',
            });
          }
        }
      }
    });

    if (matrixSelectionCorners?.length) {
      for (let i = 0; i < matrixSelectionCorners.length; i++) {
        const point = matrixSelectionCorners[i];
        if (point.types?.length === 2) {
          const pt1 = point.types[0];
          const pt2 = point.types[1];
          if (
            (pt1 === 'br' && pt2 === 'bl') ||
            (pt1 === 'bl' && pt2 === 'br') ||
            (pt1 === 'tl' && pt2 === 'tr') ||
            (pt1 === 'tr' && pt2 === 'tl') ||
            (pt1 === 'bl' && pt2 === 'tl') ||
            (pt1 === 'tl' && pt2 === 'bl') ||
            (pt1 === 'br' && pt2 === 'tr') ||
            (pt1 === 'tr' && pt2 === 'br')
          ) {
            matrixSelectionCorners.splice(i, 1);
            i = i - 1;
          }
        } else if (point.types?.length === 4) {
          matrixSelectionCorners.splice(i, 1);
          i = i - 1;
        }
      }
      matrixSelectionCorners = matrixSelectionCorners.sort((a, b) => a.y - b.y);
      let startPoint = matrixSelectionCorners[0];
      matrixSelectionCorners.forEach(corner => {
        if (corner.y === startPoint.y && corner.x < startPoint.x) {
          startPoint = corner;
        }
      });
      if (startPoint) {
        const edges = {
          tl: 'M-0.2 -0.2L1.2 -0.2L1.2 0.2L0.2 0.2L0.2 1.2L-0.2 1.2L-0.2 -0.2Z',
          tr: 'M-1.2 -0.2L0.2 -0.2L0.2 1.2L-0.2 1.2L-0.2 0.2L-1.2 0.2L-1.2 -0.2Z',
          bl: 'M-0.2 -1.2L-0.2 0.2L1.2 0.2L1.2 -0.2L0.2 -0.2L0.2 -1.2L-0.2 -1.2Z',
          br: 'M-1.2 0.2L0.2 0.2L0.2 -1.2L-0.2 -1.2L-0.2 -0.2L-1.2 -0.2L-1.2 0.2Z',
        };
        const points = [];
        points.push(startPoint);
        let nextPoint = startPoint;
        let runs = 0;
        matrixSelectionContour = 'M' + nextPoint.x + ' ' + nextPoint.y;
        while (nextPoint && runs < matrixSelectionCorners.length) {
          runs += 1;
          const prevPoint = nextPoint;
          nextPoint = getNextAreaCorner(nextPoint, matrixSelectionBounds, matrixSelectionCorners);
          if (nextPoint) {
            let edge = nextPoint.line?.type ? (prevPoint.line?.type ? prevPoint.line.type + '-' + nextPoint.line.type : 'tl') : '';
            edge = edge.replace('right-down', 'tr').replace('top-left', 'tr');
            edge = edge.replace('left-down', 'tl').replace('top-right', 'tl');
            edge = edge.replace('right-top', 'br').replace('down-left', 'br');
            edge = edge.replace('left-top', 'bl').replace('down-right', 'bl');

            let edgeD = edges[edge];
            if (nextPoint.line.start.y === nextPoint.line.end.y) {
              const edgeLengthX = nextPoint.line.start.x > nextPoint.line.end.x ? nextPoint.line.start.x - nextPoint.line.end.x : nextPoint.line.end.x - nextPoint.line.start.x;
              nextPoint.edgeLengthX = edgeLengthX > 2.4 ? 1.2 : Number((edgeLengthX / 2).toFixed(1));
              nextPoint.edgeLengthY = 1.2;
              edgeD = edgeD.replaceAll('L1.2', 'L' + nextPoint.edgeLengthX);
              edgeD = edgeD.replaceAll('L-1.2', 'L-' + nextPoint.edgeLengthX);
            } else if (nextPoint.line.start.x === nextPoint.line.end.x) {
              const edgeLengthY = nextPoint.line.start.y > nextPoint.line.end.y ? nextPoint.line.start.y - nextPoint.line.end.y : nextPoint.line.end.y - nextPoint.line.start.y;
              nextPoint.edgeLengthX = 1.2;
              nextPoint.edgeLengthY = edgeLengthY > 2.4 ? 1.2 : Number((edgeLengthY / 2).toFixed(1));
              edgeD = edgeD.replaceAll('1.2L', '' + nextPoint.edgeLengthX + 'L');
              edgeD = edgeD.replaceAll('-1.2L', '-' + nextPoint.edgeLengthX + 'L');
              edgeD = edgeD.replaceAll('1.2Z', '' + nextPoint.edgeLengthX + 'Z');
              edgeD = edgeD.replaceAll('-1.2Z', '-' + nextPoint.edgeLengthX + 'Z');

              if (prevPoint.edgeLengthX < 1.2) {
                edgeD = edgeD.replaceAll('L1.2', 'L' + prevPoint.edgeLengthX);
                edgeD = edgeD.replaceAll('L-1.2', 'L-' + prevPoint.edgeLengthX);
              }
            }

            points[points.length - 1].edge = edgeD;
            points.push(nextPoint);
            matrixSelectionContour += 'L' + nextPoint.x + ' ' + nextPoint.y;
            matrixSelectionLines.push(nextPoint.line);
            if (nextPoint.x === startPoint.x && nextPoint.y === startPoint.y) {
              matrixSelectionContour += 'Z';
              points.splice(0, 1);
              nextPoint = null;
              if (points.length >= matrixSelectionCorners.length) {
                matrixSelectionCorners = points;
              } else {
                const emptyCorners = [];
                matrixSelectionCorners.forEach(originCorner => {
                  const existCorner = points.filter(obj => {
                    return obj.id === originCorner.id;
                  });
                  if (!existCorner?.length) {
                    emptyCorners.push(originCorner);
                    Object.values(fictiveSections).forEach(section => {
                      const isSelected = section.type != 'separator' && Boolean(sectionsSelection[section.id] || fictiveSectionsSelection[section.id]);
                      if (!isSelected) {
                        if (Number(originCorner.x.toFixed(1)) === Number(section.x.toFixed(1))) {
                          const existBound = matrixSelectionBounds.filter(obj => {
                            return obj.id === 'bound_' + section.id;
                          });

                          if (sectionsSelection[section.id] && !existBound?.length) {
                            matrixSelectionBounds.push({
                              id: 'bound_' + section.id,
                              x: section.x,
                              y: section.y,
                              width: section.width,
                              height: section.height,
                              isSeparator: section.type === 'separator',
                            });
                          }
                        }
                      }
                    });
                  }
                  matrixSelectionCorners = points;
                });
              }
              break;
            }
          }
        }
      }
    }

    matrixSelectionCorners.forEach((corner, index) => {
      const prev = index > 0 ? index - 1 : matrixSelectionCorners.length - 1;
      const next = index < matrixSelectionCorners.length - 1 ? index + 1 : 0;
      const prevC = matrixSelectionCorners[prev];
      const nextC = matrixSelectionCorners[next];

      const isRight = (prevC.x < corner.x && nextC.x === corner.x) || (prevC.x === corner.x && nextC.x < corner.x);
      const isTop = !((prevC.y < corner.y && nextC.y === corner.y) || (prevC.y === corner.y && nextC.y < corner.y));

      let visibleCorner = false;
      matrixSelectionBounds.forEach(bounds => {
        if (isTop && !isRight && Number(bounds.x.toFixed(1)) === Number(corner.x.toFixed(1)) && Number(bounds.y.toFixed(1)) === Number(corner.y.toFixed(1))) {
          visibleCorner = true;
        } else if (isTop && isRight && Number((bounds.x + bounds.width).toFixed(1)) === Number(corner.x.toFixed(1)) && Number(bounds.y.toFixed(1)) === Number(corner.y.toFixed(1))) {
          visibleCorner = true;
        } else if (!isTop && isRight && Number((bounds.x + bounds.width).toFixed(1)) === Number(corner.x.toFixed(1)) && Number((bounds.y + bounds.height).toFixed(1)) === Number(corner.y.toFixed(1))) {
          visibleCorner = true;
        } else if (!isTop && !isRight && Number(bounds.x.toFixed(1)) === Number(corner.x.toFixed(1)) && Number((bounds.y + bounds.height).toFixed(1)) === Number(corner.y.toFixed(1))) {
          visibleCorner = true;
        }
      });

      if (!visibleCorner) {
        corner.edge = '';
      }
    });

    // Remove selectedArea separators help sections, created in PageMatrixCornerRenderer !
    if (Object.values(fictiveSections).length) {
      Object.values(fictiveSections).forEach(section => {
        if (section?.type === 'helpSec') {
          if (page?.sections[section.id]) {
            delete page.sections[section.id];
          }
          if (sectionsSelection && sectionsSelection[section.id]) {
            delete sectionsSelection[section.id];
          }
        }
      });
    }

    return {
      bounds: matrixSelectionBounds,
      corners: matrixSelectionCorners,
      lines: matrixSelectionLines,
      d: matrixSelectionContour,
    };
  };

  let selectionPoligonPoints = '';
  if (selectionArea?.corners.length > 0) {
    selectionArea.corners.map(corner => {
      selectionPoligonPoints = selectionPoligonPoints + '' + corner.x + ',' + corner.y + ' ';
    });
  }

  const isEditModeEnabled = floatableInputVisible;
  const matrixSelection = getMatrixSelectionArea();
  const isCellCoverAvailable = !!matrixSelection.d;
  const isSelectionAreaAvailable = selectionPoligonPoints.length > 0;
  const isSelectionAreaCornersAvailable = !!selectionArea?.corners?.length;
  const isCellCorenersAvailable = !isEditModeEnabled && matrixSelection.corners.length >= 4 && matrixSelection.bounds.length > 0;

  return (
    <>
      <g id="matrixSelection_path_group">
        {isCellCoverAvailable && <path id="matrixSelection_path" d={matrixSelection.d} {...getMatrixSelectionStyles({ isEditModeEnabled })} />}
      </g>
      <g id="matrixSelection_corners">
        {isSelectionAreaAvailable && <polygon points={selectionPoligonPoints} fill="#2097a011" stroke={colors.primary} strokeDasharray={STROKE_DASHARRAY} strokeWidth={STROKE_WIDTH} />}
        {isSelectionAreaCornersAvailable && selectionArea.corners.map(corner => {
          return (
            <circle
              id={'selection_area__corner_' + corner.id}
              key={'selection_area__corner_' + corner.id}
              stroke={colors.white}
              fill={colors.primary}
              strokeWidth={STROKE_WIDTH}
              cx={corner.x}
              cy={corner.y}
              r={0.15}
            />
          );
        })}
        {isCellCorenersAvailable && matrixSelection.corners.map(corner => {
          return (
            <PageMatrixCornerRenderer
              key={corner.id}
              page={page}
              fictiveSections={fictiveSections}
              corner={corner}
              matrixSelectionArea={getMatrixSelectionArea()}
              selectionArea={selectionArea}
              setSelectionArea={setSelectionArea}
              sectionsSelection={sectionsSelection}
              fictiveSectionsSelection={fictiveSectionsSelection}
              parentShield={selectedShield}
            />
          );
        })}
      </g>
    </>
  );
};

export default MatrixSelection;
